import { unsafeRefine } from './common';

export type Nullable<T> = T | null | undefined;

export function isNonNullable<A>(value: Nullable<A>): value is NonNullable<A> {
  return value !== null && value !== undefined;
}

export const nonNullable = unsafeRefine(isNonNullable);
